export default __webpack_public_path__ + "static/media/Frame 96.e1932a89.svg";